var _path, _circle, _path2, _path3, _mask, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle2Th(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325 192H234V220.664C241.467 210.556 253.468 204 267 204C286.552 204 302.907 217.686 307.009 236H325V192Z",
    fill: "url(#paint0_linear_6471_7900)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 147.5,
    r: 43.5,
    stroke: "#A200FF",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 146.5L122 166L155.5 132.5",
    stroke: "#A200FF",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 64H18.5V70.5V236V242.5H25H43.075C43.3502 237.924 44.3761 233.55 46.0311 229.5H31.5V77H229V129V229.5H121.969C123.624 233.55 124.65 237.924 124.925 242.5H226.075C226.809 230.291 232.887 219.522 242 212.501V135.5H271.364L316.5 192.269V229.5H304.969C306.624 233.55 307.65 237.924 307.925 242.5H323H329.5V236V190V187.731L328.088 185.955L279.588 124.955L277.636 122.5H274.5H242V70.5V64H235.5H25Z",
    fill: "#A200FF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_6471_7900",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113 245C113 261.016 100.016 274 84 274C67.9837 274 55 261.016 55 245C55 228.984 67.9837 216 84 216C100.016 216 113 228.984 113 245ZM125 245C125 267.644 106.644 286 84 286C61.3563 286 43 267.644 43 245C43 222.356 61.3563 204 84 204C106.644 204 125 222.356 125 245ZM296 245C296 261.016 283.016 274 267 274C250.984 274 238 261.016 238 245C238 228.984 250.984 216 267 216C283.016 216 296 228.984 296 245ZM308 245C308 267.644 289.644 286 267 286C244.356 286 226 267.644 226 245C226 222.356 244.356 204 267 204C289.644 204 308 222.356 308 245Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 282C104.435 282 121 265.435 121 245H105C105 256.598 95.598 266 84 266V282ZM47 245C47 265.435 63.5655 282 84 282V266C72.402 266 63 256.598 63 245H47ZM84 208C63.5655 208 47 224.565 47 245H63C63 233.402 72.402 224 84 224V208ZM121 245C121 224.565 104.435 208 84 208V224C95.598 224 105 233.402 105 245H121ZM84 294C111.062 294 133 272.062 133 245H117C117 263.225 102.225 278 84 278V294ZM35 245C35 272.062 56.938 294 84 294V278C65.7746 278 51 263.225 51 245H35ZM84 196C56.938 196 35 217.938 35 245H51C51 226.775 65.7746 212 84 212V196ZM133 245C133 217.938 111.062 196 84 196V212C102.225 212 117 226.775 117 245H133ZM267 282C287.435 282 304 265.435 304 245H288C288 256.598 278.598 266 267 266V282ZM230 245C230 265.435 246.565 282 267 282V266C255.402 266 246 256.598 246 245H230ZM267 208C246.565 208 230 224.565 230 245H246C246 233.402 255.402 224 267 224V208ZM304 245C304 224.565 287.435 208 267 208V224C278.598 224 288 233.402 288 245H304ZM267 294C294.062 294 316 272.062 316 245H300C300 263.225 285.225 278 267 278V294ZM218 245C218 272.062 239.938 294 267 294V278C248.775 278 234 263.225 234 245H218ZM267 196C239.938 196 218 217.938 218 245H234C234 226.775 248.775 212 267 212V196ZM316 245C316 217.938 294.062 196 267 196V212C285.225 212 300 226.775 300 245H316Z",
    fill: "#A200FF",
    mask: "url(#path-5-inside-1_6471_7900)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6471_7900",
    x1: 234,
    y1: 236,
    x2: 268.06,
    y2: 165.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A200FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle2Th);
export default __webpack_public_path__ + "static/media/vehicle2_TH.023bd37625568c25cc6567049a74cf78.svg";
export { ForwardRef as ReactComponent };